// @module NVT.NewContactRegistration.NewContactRegistration
define('NVT.NewContactRegistration.NewContactRegistration.View'
	, [
		'nvt_newcontactregistration_newcontactregistration.tpl'

		, 'NVT.NewContactRegistration.NewContactRegistration.Model'

		, 'Backbone'

		, 'jQuery'

		, 'Utils'

		, 'GlobalViews.Message.View'

		, 'underscore'

	]
	, function (
		nvt_newcontactregistration_newcontactregistration_tpl

		, ContactRegisterByCompanyModel

		, Backbone

		, jQuery

		, Utils

		, GlobalViewsMessageView

		, _
	) {
		'use strict';

		// @class NVT.NewContactRegistration.NewContactRegistration.View @extends Backbone.View
		return Backbone.View.extend({

			template: nvt_newcontactregistration_newcontactregistration_tpl

			, initialize: function (options) {

				var self = this;
					self.companyListdetails = [];
					self.assignuen = '';
				this.options.LoginRegisterPage.on('beforeRegister', function (formFields) {
					jQuery(".invalidcomment").text('');
					self.clearError();
					
					if( jQuery("[name='corporateindividual']").val() == '1' && jQuery("input[name='searchCompany']").val() == '' && jQuery("[name='addlocalforeigner_category']").val() == '1')
					{
						jQuery("input[name='searchCompany']").focus();
						self.showMessage("UEN or Registration number is required.",'error','mysearchCompany');
						return jQuery.Deferred().reject();
					}

					if( jQuery("[name='corporateindividual']").val() == '1' && jQuery("input[name='company']").val() =='')
					{
						jQuery(".invalidcomment").text("We are unable to find your organisation in our records. Please complete the details below to create an acount with us.");
						self.showMessage("Organization Name is required.",'error','company');
						return jQuery.Deferred().reject();
					}

						//	jQuery("input[name='uen']").val() != ''
					if (jQuery("[name='corporateindividual']").val() == '1') {

						if(jQuery("input[name='searchCompany']").val() == null || jQuery("input[name='searchCompany']").val() =='')
						{
							jQuery("input[name='searchCompany']").focus();
							self.showMessage("UEN or Registration number is required.",'error','mysearchCompany');
							return jQuery.Deferred().reject();
						}

						var mysearchCompany_val = jQuery("[name='uen']").val();
							self.assignuen = jQuery("input[name='searchCompany']").val();

						if(formFields.firstname =='')
						{
							jQuery("[name='firstname']").focus();
							return jQuery.Deferred().reject();
						}
						if(formFields.lastname =='')
						{
							jQuery("[name='lastname']").focus();
							return jQuery.Deferred().reject();
						}
						if(formFields.jobtitle =='')
						{
							jQuery("[name='jobtitle']").focus();
							return jQuery.Deferred().reject();
						}

						if(formFields.phone =='' || formFields.phone.length < 8 )
						{
							jQuery("[name='phone']").focus();
							return jQuery.Deferred().reject();
						}

						if(formFields.email =='')
						{
							jQuery("[name='email']").focus();
							return jQuery.Deferred().reject();
						}

						var password = jQuery("#register-password").val();
						if (!self.chkpwdpolicy(password)) {
							var content = '';
							content += Utils.translate('Invalid password.<br> Password should contain from 3 of the following 4 categories <br>')
								+ Utils.translate('1. English uppercase characters (A to Z)<br>')
								+ Utils.translate('2. English lowercase (a to z)<br>')
								+ Utils.translate('3. Base 10 digit<br>')
								+ Utils.translate('4. Non-alphabetic characters (example $,%,&,*@)<br>');
							//self.showMessage('Invalid password format. The Password you have selected contain characters that are not recognized', 'error', 'password');
							return jQuery.Deferred().reject();
						}
						else {
							jQuery('.global-views-message-error').remove();
						}

						if( formFields.email !='' && formFields.password !='')
						{
							let email =  formFields.email ? formFields.email.toLowerCase() : '';
                        
                            // Iterate through the password to find three consecutive letters
                            // for (let i = 0; i < formFields.password.length - 2; i++) {
                            //     let substring = formFields.password.substring(i, i + 3);
                            //     // Check if the substring is present in the email
                            //     if (email.includes(substring)) {
                            //         // If found, show alert message
							// 		//self.showMessage('Your password cannot contain three consecutive letters from your email!', 'error','password');
							// 		return jQuery.Deferred().reject();
                            //     }
                            // }

                            let firstThreeLetters = email.substring(0, 3);

                            // Check if the password contains the first three letters of the email
                            if (formFields.password.includes(firstThreeLetters)) {
                                // If found, show alert message
								//self.showMessage('Password should not contain first 3 letters of the email ID.')
								return jQuery.Deferred().reject();
                            }
						}

						if ((formFields.password == formFields.password2) && formFields.email && formFields.searchCompany && formFields.firstname && formFields.lastname && formFields.jobtitle && formFields.phone) {
							var model = new ContactRegisterByCompanyModel();

							model.fetch({
								async: false,
								data: {
									'method': 'getcontactbycompany',
									'custpage_firstname': formFields.firstname,
									'custpage_lastname': formFields.lastname,
									'custpage_company': mysearchCompany_val,
									'custpage_searchCompany': formFields.searchCompany.trim(),
									'custpage_email': formFields.email,
									'password': formFields.password,
									'password2': formFields.password2,
									'jobtitle': formFields.jobtitle,
									'phone': formFields.phone
								}
							}).done(function (result) {
								if(result.sucess !='')
								{
									self.render();
								}
								else{
									if(result.id == '')
									{
										self.showErrorrs(_.translate(result.error));
									}
									else{
										self.showErrorrs(_.translate(result.error));
									}
									return jQuery.Deferred().reject();
								}								
							});
						}
						else {

						}
					}
				});
			}

			, showErrorrs: function (paramerror) {
				
				var self = this;
				self.errorcistom = paramerror;
				//if (self.error) {
					const global_view_message = new GlobalViewsMessageView({
						message: paramerror,
						type: 'error',
						closable: false
					});

					self.$('[data-type="alert-placeholder-custome-error"]').html(
						global_view_message.render().$el.html()
					);

					return jQuery.Deferred().reject();
					//self.error = null;
				//}
			}

			, clearError: function () {
				var self = this;
				self.$('[data-type="alert-placeholder-jobtitle"]').empty();
				self.$('[data-type="alert-placeholder-phone"]').empty();
				jQuery('.global-views-message-error').remove();
				self.$('[data-type="alert-placeholder-custome-error"]').empty();
				self.error = null;
			}

			, events: {
				'input [name="corporateindividual"]': 'selectselectCorporate',
				'keyup #mysearchCompany': 'searchAndGetListCompany',
				'blur [data-action="setCompanyNameBySearch"]': 'setCompanyNameBySearch',
				'mouseover [data-action="setCompanyNameBySearch"]': 'setCompanyNameBySearch',
				'keyup [data-action="setCompanyNameBySearch"]': 'setCompanyNameBySearch',
				'click #login-register-register-mysearchCompany-inputtext': 'hideError',
				'change [data-action="dataactionlocalforeigner_category"]' : 'dataactionlocalforeigner_category'
			}

			, bindings: {
				'[name="searchCompany"]': 'searchCompany',
			}

			, childViews: {

			}

			, dataactionlocalforeigner_category:function(e){

				// leble hide and show
				var self = this;
				var localforeigner_category = e.currentTarget.value;
					jQuery(".alfc").css("display","inline");
				if(localforeigner_category==2)
				{
					jQuery(".alfc").css("display","none");
				}
			}

			, chkpwdpolicy: function (password) {
				var self = this;
				// Define regular expressions for each category
				const lengthRegex = /^.{12,}$/; // Minimum 12 characters
				const uppercaseRegex = /[A-Z]/; // At least one uppercase letter
				const lowercaseRegex = /[a-z]/; // At least one lowercase letter
				const numberRegex = /[0-9]/; // At least one number
				const specialCharRegex = /[!@#$%^&*()_+\-=]/; // At least one special character from the specified set
				const spaceRegex = /\s/; // Space character

				// Count how many categories the password satisfies
				let categoryCount = 0;
				if (uppercaseRegex.test(password)) categoryCount++;
				if (lowercaseRegex.test(password)) categoryCount++;
				if (numberRegex.test(password)) categoryCount++;
				if (specialCharRegex.test(password)) categoryCount++;

				// Check if the password meets the minimum length and satisfies at least 3 out of 4 categories
				//return lengthRegex.test(password) && categoryCount >= 3;
				return lengthRegex.test(password) && !spaceRegex.test(password) && categoryCount >= 3;

			}

			, showMessage: function (message, type, field) {
				jQuery('.global-views-message-error').remove();
				var messageView = new GlobalViewsMessageView
					({
						message: message
						, type: type
						, closable: true
					});
				if (typeof field !== 'undefined') {
					self.$('[data-input="' + field + '"]').append(messageView.render().$el);
				}
				else {
					self.$('form').empty().html(messageView.render().$el);
				}
			}

		
			, selectselectCorporate: function (e) {
				var self = this;
					self.companyListdetails = [];

				this.getcurrentindexval = e.currentTarget.value;
				jQuery("input[name='company']").val('');
				jQuery("#mysearchCompany").val('');
				jQuery("input[name='company']").prop('disabled', true);
				jQuery("input[name='uen']").val('');
				self.assignuen = '';

				if (this.getcurrentindexval == '2') {
					jQuery(".login-register-register-form-controls-group-cpny").css("display", "none");
					jQuery(".login-register-register-form-controls-group-regcomp").css("display", "none");
					jQuery(".cls-job-title").hide();
					jQuery(".corporate-individuald-escription").text(SC.CONFIGURATION.NewContactRegistration.customindividual);
				}
				else {
					this.getcurrentindexval = "1";
					jQuery(".login-register-register-form-controls-group-cpny").css("display", "block");
					jQuery(".login-register-register-form-controls-group-regcomp").css("display", "block");
					jQuery("input[name='company']").prop('disabled', true);
					jQuery(".cls-job-title").show();
					jQuery(".corporate-individuald-escription").text(SC.CONFIGURATION.NewContactRegistration.customcorporate);
				}
			}

			, setCompanyNameBySearch: function (e) {
				
				jQuery("input[name*='company']").prop('disabled', true);

				if ( jQuery("[name='corporateindividual']").val() == '1') {
					var mysearchCompany_val = jQuery("input[name='uen']").val();
					if (mysearchCompany_val) {
						jQuery("input[name*='company']").prop('disabled', true);
					}
					else{
						jQuery("input[name*='company']").prop('disabled', false);
					}
				}
			}

			, searchAndGetListCompany: function (e) {
				e.preventDefault();
				var self = this;
				self.companyListdetails = [];
				var getsearchkeyword = jQuery('#mysearchCompany').val().trim();
					jQuery("input[name='company']").val('');
					jQuery("input[name='company']").prop('disabled', false);
					jQuery("input[name='uen']").val('');
					jQuery(".invalidcomment").text('');
					jQuery('.global-views-message-error').remove();
					
				if (getsearchkeyword != "") {
					var model = new ContactRegisterByCompanyModel();
					model.fetch({
						data: {
							'getsearchkeyword': getsearchkeyword,
							'method': 'companyListSearching'
						}
					})
						.done(function (response) {

							if(response.length === 0)
							{
								jQuery(".invalidcomment").text("We are unable to find your organisation in our records. Please complete the details below to create an acount with us.");
								self.showMessage("Organization Name is required.",'error','company');	
							}
							else
							{
								self.companyListdetails = response;
								jQuery('.global-views-message-error').remove();
								jQuery("input[name*='company']").prop('disabled', true);
								for (var n = 0; n < response.length; n++) {
									jQuery("input[name='uen']").val(response[0].internalid);
									jQuery("input[name='company']").val( response[0].name);
								}
							}							
						});
				}
			}

			//@method getContext @return NVT.NewContactRegistration.NewContactRegistration.View.Context

			, getContext: function getContext() {

				var self = this;
					
				if(self.companyListdetails.length > 0)
				{
					jQuery("input[name='uen']").val(self.companyListdetails[0].internalid);
					jQuery("input[name='company']").val(self.companyListdetails[0].name);
					self.assignuen = self.companyListdetails[0].uenno;
				}

				return {

					assignuen : self.assignuen ,

					NewContactRegistrationdescription: this.getcurrentindexval == '2' ? SC.CONFIGURATION.NewContactRegistration.customindividual : SC.CONFIGURATION.NewContactRegistration.customcorporate

				};
			}
		});
	});
